import { Suspense, lazy } from 'react'
import { featureFlags } from 'app/app-feature-flags'
import { Head } from 'features/head'
import { BullsEyePageSkeleton } from 'shared/skeletons/page-skeletons/bulls-eye-page-skeleton'

// NOTE: the off-chain launch replaces the on-chain game for everyone; the on-chain chunk is not even loaded then
const ModeBullsEye =
  featureFlags.offchainOnly ?
    lazy(() => import('features/mode-bulls-eye-demo'))
  : lazy(() => import('features/mode-bulls-eye'))

export const BullsEyeModePage: React.FC = () => {
  return (
    <>
      <Head title='Bulls Eye' />
      <Suspense fallback={<BullsEyePageSkeleton />}>
        <ModeBullsEye />
      </Suspense>
    </>
  )
}
